module.exports = __webpack_public_path__ + "img/craigslist.8ac08ca4.svg";